export const _arg1 = (state, arg1) => arg1
export const _arg2 = (state, arg1, arg2) => arg2
export const _arg3 = (state, arg1, arg2, arg3) => arg3

export const getToWfidAttribute = item => item.toWfid || item.wfcid
export const getFromWfidAttribute = item => item.fromWfid || item.wffid
export const identity = x => x
